import { Button, Stack, Typography } from "@mui/material";
import { routerPaths } from "../../constants/Paths";
import { Link, useParams } from "react-router-dom";

import PbxServerDetailsSectionComponent from "../../components/panel/pbx-server-details/broadcasting-sub/PbxServerDetailsSection";

export default function ServersDetailsPage() {
  const { id } = useParams();

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "8px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "row", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "center" }}
            mb={{ xs: "6px", md: "0" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={({ palette }) => palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                جزئیات سرور pbx
              </Typography>
              <Typography
                variant="footerDemiBold"
                color={({ palette }) => palette.complement[300]}
                sx={{
                  mb: "20px",
                }}
              >
                جزئیات سرور های تماس
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap="12px"
            >
              <Button variant="contained">
                <Typography
                  variant="footerRegular"
                  component={Link}
                  color={(theme) => theme.palette.dominant[100]}
                  sx={{
                    textDecoration: "none",
                  }}
                  to={`/${routerPaths.SERVERS}`}
                >
                  بازگشت
                </Typography>
              </Button>
            </Stack>
          </Stack>
        </Stack>

        <PbxServerDetailsSectionComponent id={id!} />
      </Stack>
    </>
  );
}
